var _global;
const channel = (_global = global) !== null && _global !== void 0 && _global.BroadcastChannel ? new global.BroadcastChannel('truqc-broadcast') : {
  postMessage: () => {},
  onmessage: () => {}
};
export default channel;